import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";

import { useAuth } from "@equidefi/portals/hooks/useAuth";
import { useSavedProfiles } from "@equidefi/portals/hooks/useSavedProfiles";

import { useUserInvestments } from "@/hooks/useInvestments";
import useWorkflowPosition from "@/hooks/useWorkflowPosition";
import { useWorkflowContext } from "@/pages/workflow/context/WorkflowContext";

import ExistInvestorRegister from "./ExistInvestorRegister";
import Register from "./Register";

const WorkflowRegistration = (props) => {
  const { offering } = useWorkflowContext();
  const params = useParams();
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();

  const { data: investments, isFetchedAfterMount: investmentsFetched } = useUserInvestments(
    { offering_id: offering?.id },
    { refetchOnMount: "always", refetchOnReconnect: "always" },
  );

  const { data: savedProfiles, isFetchedAfterMount: savedProfilesFetched } = useSavedProfiles({
    enabled: isLoggedIn,
  });

  useWorkflowPosition(1);

  useEffect(() => {
    if (!isLoggedIn) return;
    if (!investmentsFetched || !savedProfilesFetched) return;

    if (investments?.length > 0) {
      navigate(`/offerings/${params.slug}/choose`, { replace: true });
      return;
    }

    if (savedProfiles?.length > 0) {
      navigate(`/offerings/${params.slug}/reinvest`, { replace: true });
    }
  }, [isLoggedIn, params?.slug, investments, investmentsFetched, savedProfiles, savedProfilesFetched, navigate]);

  return isLoggedIn ? <ExistInvestorRegister offering={offering} /> : <Register offering={offering} />;
};

export default WorkflowRegistration;
